// Reactions defined in blazes

import { BelayUserConnection } from './belay';
import { PageInfo } from './blazesPageInfo';

export enum ReactionKind {
  Like = 'urn:alltrails:reactions:like'
}

export enum ReactionLinkRel {
  Add = 'urn:alltrails:reactions:add',
  Remove = 'urn:alltrails:reactions:remove',
  Reactors = 'urn:alltrails:reactions:reactors'
}

export type AddReactionLink = {
  href: string;
  rel: ReactionLinkRel.Add;
  method: 'POST';
  payload: string;
  contentType: 'application/json';
};

export type RemoveReactionLink = {
  href: string;
  rel: ReactionLinkRel.Remove;
  method: 'DELETE';
};

export type FetchReactorsLink = {
  href: string;
  rel: ReactionLinkRel.Reactors;
  method: 'GET';
};

export type ReactionLink = AddReactionLink | RemoveReactionLink | FetchReactorsLink;

export type Reaction = {
  kind: ReactionKind;
  count: number;
  links: ReactionLink[];
  me: boolean;
};

export type ReactionSummary = {
  description: string;
  reactions: Reaction[];
};

// Response to adding/removing a reaction
export type ReactionResponse = {
  itemId: string;
  reactionSummary: ReactionSummary;
};

export type Reactor = { connection: BelayUserConnection; reactionKind: ReactionKind };

// Response to fetching a reactors
export type ReactorsResponse = {
  reactors: Reactor[];
  pageInfo: PageInfo;
  links: { href: string; rel: 'next' }[];
};

